import { render, staticRenderFns } from "./ExchangeSuccess.vue?vue&type=template&id=628430b4&scoped=true&"
import script from "./ExchangeSuccess.vue?vue&type=script&lang=js&"
export * from "./ExchangeSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeSuccess.vue?vue&type=style&index=0&id=628430b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628430b4",
  null
  
)

export default component.exports